/* eslint-disable no-undef */

import api from '../api'

export const GET_PERIODS = 'GET_PERIODS'

export default {
  state: {allPeriods: []},
  mutations: {
    [GET_PERIODS] (state, periods) {
      Object.assign(state, periods)
    }
  },
  actions: {
    [GET_PERIODS] ({commit}, user) {
      return new Promise(function (resolve, reject) {
        api.getPeriods(window.$app, user).then((data) => {
          commit(GET_PERIODS, data)
          resolve()
        }, (data) => {
          commit(GET_PERIODS, {})
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/period.js